export default __webpack_public_path__ + "static/media/google-play-logo.b0526c6f.svg";